import { GetServerSidePropsContext } from "next";
import Home from "views/index";
import {
	GetFrontPlayground,
	GetFrontModules,
	GetFrontModulesResp,
	GetSeoInfo,
} from "services/page/app";
import { parseProductTagFromUrl } from "utils/playground/url";
import { IncomingMessage } from "http";
import { reconstructFrontMods } from "serverutils/initProductInfo";
import { CommonRuntime, getMeta } from "utils/runtime";
import { isNotBlankArray } from "utils/array";
import e from "utils/catchAsyncError";

type IncomingMessagePro = IncomingMessage & {
	cookies: { [key: string]: string };
	runtime?: CommonRuntime;
};
export interface GetServerSidePropsContextPro extends GetServerSidePropsContext {
	req: IncomingMessagePro;
}

export const getServerSideProps = async ({ req, query }: GetServerSidePropsContextPro) => {
	const runtime = req.runtime;
	const { id, version } = runtime;

	const meta = getMeta(runtime);

	const tag: string = (query.tag as string) || "";
	const [, seoInfo] = await e(GetSeoInfo)({ pageId: id }, { runtime });

	const [, playgroundData] = await e(GetFrontPlayground)(
		{
			id,
			meta,
			version,
		},
		{ runtime },
	);

	const tagQuery = parseProductTagFromUrl(tag || "");
	let frontMods = {};
	if (isNotBlankArray(playgroundData?.modules)) {
		const moduleId: string[] = [
			...playgroundData.modules
				.filter((item) => item.header?.position)
				.map((item) => item.id),
		];
		const modRes: GetFrontModulesResp = await GetFrontModules(
			{
				moduleId,
				meta,
			},
			{
				runtime,
			},
		);
		frontMods = modRes?.mods
			? await reconstructFrontMods({
					mods: modRes.mods,
					tagQuery,
					runtime: req.runtime,
			  })
			: {};
	}

	return {
		props: {
			modules: playgroundData?.modules || [],
			page: playgroundData?.page || null,
			frontModules: frontMods ? Object.values(frontMods) : [],
			runtime,
			tagQuery,
			title:
				seoInfo?.multiTitle?.[runtime.languageCode] ||
				seoInfo?.multiTitle?.["en"] ||
				seoInfo?.pageName ||
				playgroundData?.page?.name ||
				"",
		},
	};
};

export default Home;
